import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';

// helpers
import { getUTCDate } from '../../../helpers/dateTimeHelpers';

// components
import FormulaDatePicker from './FormulaDatePicker';

interface StyledProps {
    isDisabled?: boolean;
}
interface StartStartInputProps {
    isDisabled?: boolean;
    start: Date | null;
    setStart: (startDate: Date | null) => void;
    stop: Date | null;
    setStop: (endDate: Date | null) => void;
}
const StartStopInput: React.FC<React.PropsWithChildren<StartStartInputProps>> =
    ({ isDisabled, start, setStart, stop, setStop }) => {
        return (
            <Container>
                <InputSection>
                    <LabelRow>
                        <Header>Start date</Header>
                        <TimezoneTag>UTC</TimezoneTag>
                    </LabelRow>
                    <StyledCalendarInput isDisabled={isDisabled}>
                        <FormulaDatePicker
                            selectedDate={start}
                            setSelectedDate={(startDate: Date) =>
                                setStart(startDate)
                            }
                            isDisabled={isDisabled}
                            minDate={getUTCDate()}
                            maxDate={stop}
                            isClearable={true}
                        />
                    </StyledCalendarInput>
                </InputSection>

                <InputSection>
                    <LabelRow>
                        <Header>Expire date</Header>
                        <TimezoneTag>UTC</TimezoneTag>
                    </LabelRow>
                    <StyledCalendarInput isDisabled={isDisabled}>
                        <FormulaDatePicker
                            selectedDate={stop}
                            setSelectedDate={(stopDate: Date) =>
                                setStop(stopDate)
                            }
                            isDisabled={isDisabled}
                            minDate={start || getUTCDate()}
                            maxDate={stop}
                            isClearable={true}
                        />
                    </StyledCalendarInput>
                </InputSection>
            </Container>
        );
    };

export default StartStopInput;

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(3),
});

const InputSection = styled.div({
    display: 'flex',
    flexDirection: 'column',
});

const LabelRow = styled.div({
    display: 'flex',
    alignItems: 'baseline',
    gap: aampeTheme.spacing4(1),
});

const Header = styled.span({
    fontWeight: 500,
    color: aampeTheme.colors.gray800,
    fontSize: '16px',
    lineHeight: '20px',
});

const TimezoneTag = styled.span({
    fontSize: '11px',
    fontWeight: 400,
    color: aampeTheme.colors.solidWG01,
    lineHeight: '16px',
    letterSpacing: '0.02em',
    whiteSpace: 'nowrap',
});

const StyledCalendarInput = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isDisabled', // Prevent 'isDisabled' from being forwarded
})<StyledProps>(({ isDisabled }) => ({
    display: 'flex',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    alignItems: 'center',
}));
